import React from 'react';
import { ArrowRight, MapPin } from 'lucide-react';
import { IMAGES, LOGOS } from '../mock';

export default function Hero() {
  return (
    <section id="top" className="relative pt-20 min-h-[92vh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Rozdzielnica i szafy sterownicze w hali przemysłowej" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0f1a2b]/85" />
        <div className="absolute inset-0 dot-pattern-dark opacity-40 mix-blend-overlay" />
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-8 pt-16 md:pt-20 pb-16 text-center text-white flex flex-col items-center">
        {/* Company Logo on light backdrop for visibility */}
        <div className="bg-white/95 backdrop-blur rounded-2xl p-5 md:p-6 shadow-2xl">
          <img
            src={LOGOS.main}
            alt="Inżynieria Elektryczna Adrian Nowak"
            className="w-32 md:w-40 h-auto block"
          />
        </div>

        {/* Main headline - company tagline */}
        <h1 className="mt-8 font-heading font-extrabold text-[26px] leading-[1.15] sm:text-[32px] md:text-[40px] lg:text-[46px] tracking-tight max-w-5xl">
          Inżynieria Elektryczna Adrian Nowak, kompleksowe usługi inżynieryjne dla przemysłu, budownictwa i inwestorów.
          <span className="block mt-2 text-[#f5c518]">Projektowanie, automatyka, kierowanie robotami oraz nadzór elektryczny.</span>
        </h1>

        {/* Small info line */}
        <p className="mt-8 max-w-2xl text-[13px] md:text-[14px] leading-relaxed text-white/70 tracking-wide uppercase">
          Działalność inżynieryjna · Automatyka Przemysłowa · Usługi Elektryczne z Uprawnieniami Budowlanymi
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#kontakt" className="inline-flex items-center gap-2 bg-[#f5c518] hover:bg-[#eab308] text-[#0f1a2b] font-semibold px-7 py-4 rounded-full transition-colors">
            Porozmawiajmy o inwestycji <ArrowRight className="h-4 w-4" />
          </a>
          <a href="#kontakt" className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 hover:bg-white/5 text-white font-semibold px-7 py-4 rounded-full transition-colors">
            Poproś o wycenę
          </a>
        </div>

        <div className="mt-10 inline-flex items-center gap-2 text-white/70 text-[13px]">
          <MapPin className="h-4 w-4 text-[#f5c518]" />
          Klonowa 3, 64-140 Włoszakowice
        </div>
      </div>
    </section>
  );
}
